import { render, staticRenderFns } from "./NotasFiscais.vue?vue&type=template&id=f4e5d7fa&"
import script from "./NotasFiscais.vue?vue&type=script&lang=js&"
export * from "./NotasFiscais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports